import React from "react";
import ReactDOM from "react-dom";

import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";


import AdminLayout from "layouts/Admin";
import AuthLayout from "layouts/Auth";
import EmptyLayout from "layouts/Empty";
import ExternalLayout from "layouts/External";

//Context
import { useAuth } from "../context/auth";


import Loading from "../components/Loading/Loading";

const hist = createBrowserHistory();

export default function RoutesComponent() {
  const { session, loading } = useAuth();
  return (
    <Router history={hist}>
      {loading && <Loading />}
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/auth/Opcoes" />} />
        <Route path="/external" render={(props) => <ExternalLayout {...props} />} />
        <Route path="/empty" render={(props) => <EmptyLayout {...props} />} />
        <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
        {session && session.tipoAcesso == "AreaRestrita" &&
          <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
        }
      </Switch>
    </Router>
  );
}
